
.header {
  height: 92px;

  .page-container-inner {
    padding-left: 20px;
    padding-right: 20px;
    max-width: 1670px;
    margin: 0 auto;
    position: relative;

    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;


    .logo {
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      height: 92px;
      width: 30%;

      a {
        background: url(../../assets/icon/logo.svg) no-repeat 100% 100%;
        width: 128px;
        height: 76px;
      }

      img {
        display: block;
        max-height: 76px;
      }
    }

    .navigation {
      width: 70%;
      display: flex;
      justify-content: flex-end;
      align-items: center;
    }
  }
}

@media (max-width: 995px) {
  .header {
    height: 76px;

    .page-container-inner {
      position: relative;

      .logo {
        height: 76px;
        width: 45%;
      }

      .navigation {
        position: absolute;
        right: 16px;
        top: 0;
        height: 76px;
        width: 55%;
      }
    }
  }
}
